const prefetchResource = (resource) => {
  const resourceLink = document.createElement('link');

  resourceLink.href = resource;
  resourceLink.rel = 'prefetch';

  document.head.appendChild(resourceLink);
};

export default prefetchResource;
